export enum cellsFileTemplateExcelEnum {
  advisorsName = 1,
  posCode = 2,
  sheduledAppointment = 3,
  statusChecIn = 4,
  absenceTypeName = 5
}
